import React from 'react'
import type { Block } from '../../types'
import { PropertyLabel, PropertyInput } from './shared'

interface VideoPropertiesProps {
  block: Block
  onUpdateBlock: (id: string, updates: Partial<Block>) => void
}

const ASPECT_RATIOS = [
  { value: '16/9', label: '16:9' },
  { value: '4/3', label: '4:3' },
  { value: '1/1', label: '1:1' },
  { value: '9/16', label: '9:16' },
]

const VIDEO_FRAMES = [
  { value: 'none', label: 'None' },
  { value: 'browser', label: 'Browser' },
  { value: 'iphone', label: 'iPhone' },
  { value: 'laptop', label: 'Laptop' },
]

export default function VideoProperties({ block, onUpdateBlock }: VideoPropertiesProps) {
  const config = (block.config || {}) as Record<string, unknown>
  const url = (config.url as string) || ''
  const aspectRatio = (config.aspectRatio as string) || '16/9'
  const frame = (config.frame as string) || 'none'

  const update = (key: string, value: unknown) => {
    onUpdateBlock(block.id, { config: { ...config, [key]: value } })
  }

  return (
    <>
      <div className="space-y-2">
        <PropertyLabel>Video URL</PropertyLabel>
        <PropertyInput
          value={url}
          placeholder="https://youtube.com/watch?v=... or https://vimeo.com/..."
          onChange={(e) => update('url', e.target.value)}
        />
        <p className="text-[11px] text-slate-400">
          Supports YouTube and Vimeo links.
        </p>
      </div>

      <div className="space-y-2">
        <PropertyLabel>Frame</PropertyLabel>
        <div className="grid grid-cols-2 gap-1.5">
          {VIDEO_FRAMES.map((opt) => (
            <button
              key={opt.value}
              onClick={() => update('frame', opt.value)}
              className={`py-2 px-2 rounded-lg border text-xs font-medium transition-all ${
                frame === opt.value
                  ? 'border-[#5048e5] bg-[#5048e5]/5 text-[#5048e5]'
                  : 'border-slate-200 text-slate-500 hover:border-slate-300'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="space-y-2">
        <PropertyLabel>Aspect Ratio</PropertyLabel>
        <div className="grid grid-cols-4 gap-1.5">
          {ASPECT_RATIOS.map((opt) => (
            <button
              key={opt.value}
              onClick={() => update('aspectRatio', opt.value)}
              className={`py-2 rounded-lg border text-xs font-bold transition-all ${
                aspectRatio === opt.value
                  ? 'border-[#5048e5] bg-[#5048e5]/5 text-[#5048e5]'
                  : 'border-slate-200 text-slate-400 hover:border-slate-300'
              }`}
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>
    </>
  )
}
